
import { getOperList, delOper, getOperStatistics } from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import addOper from "./components/add-oper-info.vue";
import queryAccount from "./components/query-account.vue";
import operAccEchart from "./components/oper-acc-echart.vue";
import customMadeQrcode from "./components/customMade-qrcode.vue";
import addMsgConfigModel from "./components/add-msg-config-model.vue";
import addPhoneConfigModel from "./components/add-phone-config-model.vue";
import i18n from "@/config/i18n";
import { getOptionList, optionKey } from "@/api/api-dict";
@Component({
  components: {
    "pi-add-oper": addOper,
    "pi-query-account": queryAccount,
    "pi-oper-acc-echart": operAccEchart,
    "pi-customMade-qrcode": customMadeQrcode,
    "pi-add-msg-config-model": addMsgConfigModel,
    "pi-add-phone-config-model": addPhoneConfigModel
  }
})
export default class ProjectconfigOper extends Vue {
  private privilege: objAny = {};
  private addElement: objAny = {};
  private selectList: object[] = [];
  private statusList: object[] = [
    { itemKey: "", itemValue: i18n.t("all") }
    // { itemKey: 0, itemValue: "未启用" },
    // { itemKey: 1, itemValue: "运营中" },
    // { itemKey: 2, itemValue: "到期停运" }
  ];
  private timeList: object[] = [
    { itemKey: "", itemValue: i18n.t("all") },
    { itemKey: 30, itemValue: i18n.t("oper.day30") },
    { itemKey: 60, itemValue: i18n.t("oper.day60") },
    { itemKey: 90, itemValue: i18n.t("oper.day90") }
  ];
  private operData: objAny = {};
  private accountAnalysis: objAny = {};
  private operTotal = 0;
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    startTime: "",
    endTime: "",
    oprStatus: "",
    expireDays: "",
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private time: object[] = [];

  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("oprName"),
      key: "oprName",
      minWidth: 140
    },
    {
      title: i18n.t("oper.companyName"),
      key: "companyName",
      minWidth: 100
    },

    {
      title: i18n.t("oper.userName"),
      key: "userName",
      minWidth: 100,
      slot: "userName"
    },
    {
      title: i18n.t("oper.oprStatus"),
      key: "oprStatusDesc",
      minWidth: 100
    },

    {
      title: i18n.t("oper.expireTime"),
      key: "expireTime",
      minWidth: 80,
      sortable: true
    },
    {
      title: i18n.t("oper.deviceCount"),
      key: "deviceCount",
      minWidth: 100,
      sortable: true,
      slot: "deviceCount"
    },
    {
      title: i18n.t("oper.createTime"),
      key: "createTime",
      minWidth: 110,
      sortable: true
    },
    {
      title: i18n.t("operation"),
      width: 180,
      slot: "action"
    }
  ];
  public timeChange(val: object[]): void {
    if (val) {
      this.formInline.startTime = val[0];
      this.formInline.endTime = val[1];
    } else {
      this.formInline.startTime = "";
      this.formInline.endTime = "";
    }
  }
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }

  public addOper(): void {
    this.addElement.open({}, "add");
  }
  public queryItem(item: objAny): void {
    this.addElement.open(item, "query");
  }
  public updataItem(item: objAny): void {
    this.addElement.open(item, "updata");
  }
  public selectItem(list: object[]) {
    this.selectList = list;
  }
  public queryLoginInfo(item: objAny): void {
    const queryAccount: objAny = this.$refs.queryAccount;
    queryAccount.open(item);
  }
  public addOperSuccess(item: objAny, type: string) {
    if (type == "new") {
      const queryAccount: objAny = this.$refs.queryAccount;
      queryAccount.open(item, type);
    }
    this.getTableList();
  }

  public delItem(item: objAny): void {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("oper.delOper") + "",
      onOk: () => {
        this.alldDelitem(item.oprPkId);
      }
    });
  }
  public customMade(item: objAny) {
    const customMadeModal: objAny = this.$refs.customMadeQrcode;
    customMadeModal.open(item);
  }

  async alldDelitem(oprPkId: string): Promise<void> {
    const ret = await delOper({ oprPkId: oprPkId });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess") + "");
      this.getTableList();
    }
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getOperList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  async getOperStatistics() {
    const ret = await getOperStatistics({});
    if (ret.status === this.$config.apiStatus) {
      this.operData = ret.data[0] || {};
      this.accountAnalysis = ret.data[1] || {};
      let operTotal = 0;
      if (this.operData.data) {
        this.operData.data.map((item: objAny) => {
          operTotal = operTotal + item.value;
        });
      }
      this.operTotal = operTotal;
      const operAccEchart: objAny = this.$refs.operAccEchart;
      operAccEchart.init(this.accountAnalysis);
    }
  }

  public msgClick(item: objAny) {
    const addMsgConfigModel: objAny = this.$refs["addMsgConfigModel"];
    addMsgConfigModel.open(item);
  }

  public phoneClick(item: objAny) {
    const addPhoneConfigModel: objAny = this.$refs["addPhoneConfigModel"];
    addPhoneConfigModel.open(item);
  }

  public created(): void {
    // const startTime = this.$common.thisTimes("yyyy-MM");
    // const endTime = this.$common.thisTimes("yyyy-MM-dd");
    // this.formInline.startTime = startTime + "-01";
    // this.formInline.endTime = endTime;
    // this.time = [this.formInline.startTime, this.formInline.endTime];
    this.getTableList();
    this.getOperStatistics();
    // this.searchInitData();
  }
  async getOptionList() {
    const ret = await getOptionList([optionKey.operStatus]); //请求字典
    this.statusList.push(...ret[optionKey.operStatus]); // 运营状态
  }

  mounted() {
    this.getOptionList();
    this.getTableList();
    this.$nextTick((): void => {
      this.addElement = this.$refs["addOper"];
    });
    this.privilege = this.$route.meta.privilegeVoObj;
  }
}
